import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UsersIcon, PlusIcon, MailIcon, ShieldCheckIcon, ClockIcon, CheckCircleIcon, TrendingUpIcon, MessageSquareIcon, BellIcon } from 'lucide-react';
export function CollaborationPage() {
  const {
    section
  } = useParams<{
    section: string;
  }>();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState<'team' | 'activity' | 'notifications'>('team');
  useEffect(() => {
    if (section) {
      setActiveSection(section as any);
    }
  }, [section]);
  const handleSectionChange = (newSection: string) => {
    setActiveSection(newSection as any);
    navigate(`/collaboration/${newSection}`);
  };
  const teamMembers = [{
    id: 1,
    name: 'Sarah Johnson',
    email: 'sarah.johnson@company.com',
    role: 'Admin',
    avatar: 'SJ',
    status: 'Active',
    lastActive: '2 hours ago'
  }, {
    id: 2,
    name: 'Michael Chen',
    email: 'michael.chen@company.com',
    role: 'Editor',
    avatar: 'MC',
    status: 'Active',
    lastActive: '5 minutes ago'
  }, {
    id: 3,
    name: 'Emily Rodriguez',
    email: 'emily.rodriguez@company.com',
    role: 'Editor',
    avatar: 'ER',
    status: 'Active',
    lastActive: '1 hour ago'
  }, {
    id: 4,
    name: 'David Park',
    email: 'david.park@company.com',
    role: 'Viewer',
    avatar: 'DP',
    status: 'Invited',
    lastActive: 'Never'
  }];
  const activities = [{
    id: 1,
    user: 'Sarah Johnson',
    action: 'created a new play',
    target: 'High-Intent Account Blitz',
    time: '10 minutes ago',
    icon: '🎯'
  }, {
    id: 2,
    user: 'Michael Chen',
    action: 'updated the program',
    target: 'Q1 ABM Campaign',
    time: '1 hour ago',
    icon: '📊'
  }, {
    id: 3,
    user: 'Emily Rodriguez',
    action: 'added a segment',
    target: 'Enterprise Tech Buyers',
    time: '3 hours ago',
    icon: '🎪'
  }, {
    id: 4,
    user: 'Sarah Johnson',
    action: 'configured integration',
    target: 'Salesforce Sync',
    time: '5 hours ago',
    icon: '🔗'
  }, {
    id: 5,
    user: 'Michael Chen',
    action: 'launched a play',
    target: 'Event Follow-up Sequence',
    time: '1 day ago',
    icon: '🚀'
  }];
  const notifications = [{
    id: 1,
    type: 'success',
    title: 'Play Completed Successfully',
    message: 'High-Intent Account Blitz completed with 85% engagement rate',
    time: '30 minutes ago',
    read: false
  }, {
    id: 2,
    type: 'warning',
    title: 'Integration Sync Issue',
    message: 'Salesforce sync encountered 3 errors. Review required.',
    time: '2 hours ago',
    read: false
  }, {
    id: 3,
    type: 'info',
    title: 'New Team Member Joined',
    message: 'David Park accepted the invitation and joined your team',
    time: '5 hours ago',
    read: true
  }, {
    id: 4,
    type: 'success',
    title: 'Segment Updated',
    message: 'Enterprise Tech Buyers segment refreshed with 234 new accounts',
    time: '1 day ago',
    read: true
  }];
  return <div className="w-full h-screen flex flex-col bg-gray-50" data-id="element-4443">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-4 lg:px-6 py-3 lg:py-4" data-id="element-4444">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" data-id="element-4445">
          <div data-id="element-4446">
            <div className="flex items-center gap-2" data-id="element-4447">
              <UsersIcon className="w-5 h-5 lg:w-6 lg:h-6 text-red-600" data-id="element-4448" />
              <h1 className="text-xl lg:text-2xl font-bold text-gray-900" data-id="element-4449">
                Team Collaboration
              </h1>
            </div>
            <p className="text-xs lg:text-sm text-gray-600 mt-1" data-id="element-4450">
              Invite team members and track activity
            </p>
          </div>
          {activeSection === 'team' && <button className="flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm" data-id="element-4451">
              <PlusIcon className="w-4 h-4" data-id="element-4452" />
              <span data-id="element-4453">Invite Team Member</span>
            </button>}
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white border-b border-gray-200 px-4 lg:px-6 overflow-x-auto" data-id="element-4454">
        <div className="flex gap-4 lg:gap-6 min-w-max" data-id="element-4455">
          {[{
          id: 'team',
          label: 'Team',
          icon: UsersIcon
        }, {
          id: 'activity',
          label: 'Activity Feed',
          icon: TrendingUpIcon
        }, {
          id: 'notifications',
          label: 'Notifications',
          icon: BellIcon
        }].map(tabItem => {
          const Icon = tabItem.icon;
          return <button key={tabItem.id} onClick={() => handleSectionChange(tabItem.id)} className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeSection === tabItem.id ? 'border-red-600 text-red-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-4456">
                <Icon className="w-4 h-4" data-id="element-4457" />
                <span className="hidden sm:inline" data-id="element-4458">{tabItem.label}</span>
              </button>;
        })}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4 lg:p-6" data-id="element-4459">
        {activeSection === 'team' && <div className="max-w-5xl mx-auto" data-id="element-4460">
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-4461">
              <div className="overflow-x-auto" data-id="element-4462">
                <table className="w-full" data-id="element-4463">
                  <thead className="bg-gray-50 border-b border-gray-200" data-id="element-4464">
                    <tr data-id="element-4465">
                      <th className="px-4 lg:px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-4466">
                        Member
                      </th>
                      <th className="px-4 lg:px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase hidden md:table-cell" data-id="element-4467">
                        Email
                      </th>
                      <th className="px-4 lg:px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase" data-id="element-4468">
                        Role
                      </th>
                      <th className="px-4 lg:px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase hidden lg:table-cell" data-id="element-4469">
                        Status
                      </th>
                      <th className="px-4 lg:px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase hidden lg:table-cell" data-id="element-4470">
                        Last Active
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200" data-id="element-4471">
                    {teamMembers.map(member => <tr key={member.id} className="hover:bg-gray-50" data-id="element-4472">
                        <td className="px-4 lg:px-6 py-4" data-id="element-4473">
                          <div className="flex items-center gap-3" data-id="element-4474">
                            <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center text-red-600 font-semibold flex-shrink-0" data-id="element-4475">
                              {member.avatar}
                            </div>
                            <div className="min-w-0" data-id="element-4476">
                              <p className="text-sm font-medium text-gray-900 truncate" data-id="element-4477">
                                {member.name}
                              </p>
                              <p className="text-xs text-gray-600 truncate md:hidden" data-id="element-4478">
                                {member.email}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 lg:px-6 py-4 text-sm text-gray-600 hidden md:table-cell" data-id="element-4479">
                          {member.email}
                        </td>
                        <td className="px-4 lg:px-6 py-4" data-id="element-4480">
                          <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded-full" data-id="element-4481">
                            {member.role}
                          </span>
                        </td>
                        <td className="px-4 lg:px-6 py-4 hidden lg:table-cell" data-id="element-4482">
                          <span className={`px-2 py-1 text-xs font-medium rounded-full ${member.status === 'Active' ? 'bg-green-50 text-green-700' : 'bg-yellow-50 text-yellow-700'}`} data-id="element-4483">
                            {member.status}
                          </span>
                        </td>
                        <td className="px-4 lg:px-6 py-4 text-sm text-gray-600 hidden lg:table-cell" data-id="element-4484">
                          {member.lastActive}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </div>}

        {activeSection === 'activity' && <div className="max-w-5xl mx-auto space-y-4" data-id="element-4485">
            {activities.map(activity => <div key={activity.id} className="bg-white rounded-lg border border-gray-200 p-4 lg:p-6 hover:shadow-md transition-shadow" data-id="element-4486">
                <div className="flex items-start gap-4" data-id="element-4487">
                  <div className="text-3xl flex-shrink-0" data-id="element-4488">{activity.icon}</div>
                  <div className="flex-1 min-w-0" data-id="element-4489">
                    <p className="text-sm lg:text-base text-gray-900 mb-1" data-id="element-4490">
                      <span className="font-semibold" data-id="element-4491">{activity.user}</span>{' '}
                      {activity.action}{' '}
                      <span className="font-semibold" data-id="element-4492">{activity.target}</span>
                    </p>
                    <p className="text-xs lg:text-sm text-gray-600 flex items-center gap-1" data-id="element-4493">
                      <ClockIcon className="w-3 h-3 lg:w-4 lg:h-4" data-id="element-4494" />
                      {activity.time}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>}

        {activeSection === 'notifications' && <div className="max-w-5xl mx-auto space-y-4" data-id="element-4495">
            {notifications.map(notification => <div key={notification.id} className={`bg-white rounded-lg border p-4 lg:p-6 hover:shadow-md transition-shadow ${notification.read ? 'border-gray-200' : 'border-red-200 bg-red-50'}`} data-id="element-4496">
                <div className="flex items-start gap-4" data-id="element-4497">
                  <div className="flex-shrink-0" data-id="element-4498">
                    {notification.type === 'success' && <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-4499" />}
                    {notification.type === 'warning' && <ShieldCheckIcon className="w-6 h-6 text-yellow-600" data-id="element-4500" />}
                    {notification.type === 'info' && <MessageSquareIcon className="w-6 h-6 text-blue-600" data-id="element-4501" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-4502">
                    <h3 className="text-sm lg:text-base font-semibold text-gray-900 mb-1" data-id="element-4503">
                      {notification.title}
                    </h3>
                    <p className="text-xs lg:text-sm text-gray-600 mb-2" data-id="element-4504">
                      {notification.message}
                    </p>
                    <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-4505">
                      <ClockIcon className="w-3 h-3" data-id="element-4506" />
                      {notification.time}
                    </p>
                  </div>
                  {!notification.read && <button className="flex-shrink-0 text-xs text-red-600 hover:text-red-700 font-medium" data-id="element-4507">
                      Mark Read
                    </button>}
                </div>
              </div>)}
          </div>}
      </div>
    </div>;
}